<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
          v-model="queryinfo.query"
          :clearable="true"
          @clear="getlist"
          style="width:200px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getlist"
          ></el-button>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-dropdown split-button type="primary" @command="getbystatus">
          {{ $t('yh.xxshzt') }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="3">{{
              $t('yh.quanbu')
            }}</el-dropdown-item>
            <el-dropdown-item command="0">{{ $t('mmb.dsh') }}</el-dropdown-item>
            <el-dropdown-item command="1">{{ $t('tongguo') }}</el-dropdown-item>
            <el-dropdown-item command="2">{{ $t('bohui') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item>
        <el-dropdown split-button type="primary" @command="getbytype">
          {{ $t('yh.txlx') }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="-1">{{
              $t('yh.quanbu')
            }}</el-dropdown-item>
            <el-dropdown-item command="0">{{ $t('yh.yhk') }}</el-dropdown-item>
            <el-dropdown-item command="1">PayPay</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="queryinfo.start"
          type="datetime"
          :placeholder="$t('qxz')"
          align="right"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="queryinfo.end"
          type="datetime"
          :placeholder="$t('qxz')"
          align="right"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-button icon="el-icon-search" circle @click="getlist"></el-button>
    </el-form>
    <el-table v-loading="loading" :data="infolist" border style="width: 100%;">
      <el-table-column prop="id" label="#" width="60"></el-table-column>
      <el-table-column prop="username" :label="$t('yhm')" width="120"></el-table-column>
      <el-table-column
        prop="money"
        :label="$t('yh.txsl')"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="actual_amount"
        :label="$t('yh.sjdz')"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="withdraw_fee"
        :label="$t('yh.txsxf')"
        width="100"
      ></el-table-column>
      <el-table-column prop="type" :label="$t('yh.txfs')" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.type == 0" type="primary">{{ $t('yh.yhk') }}</el-tag>
          <el-tag v-else-if="row.type == 1" type="success">PayPay</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="bank_info" :label="$t('yh.txxx')" min-width="180">
        <template slot-scope="{ row }">
          <div v-if="row.type == 0">
            {{ row.bank_name }} {{ row.account_number }}
          </div>
          <div v-else-if="row.type == 1">
            {{ row.paypal_account }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_at"
        :label="$t('yh.czsj')"
        :formatter="dateFormat"
        width="160"
      ></el-table-column>
      <el-table-column prop="status" :label="$t('yh.shzt')" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == 0" type="info">{{ $t('mmb.dsh') }}</el-tag>
          <el-tag v-else-if="row.status == 1" type="success">{{ $t('tongguo') }}</el-tag>
          <el-tag v-else type="danger">{{ $t('bohui') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" :label="$t('beizhu')" min-width="120"></el-table-column>
      <el-table-column :label="$t('caozuo')" width="120" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="primary"
            @click.prevent="shenhe(row.id)"
            v-if="row.status == 0"
            >{{ $t('yh.xxsh') }}</el-button
          >
          <el-button
            size="mini"
            type="info"
            @click.prevent="shenhe(row.id)"
            v-else
            >{{ $t('yh.xiangqing') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :hide-on-single-page="total <= 10"
      background
      layout="prev, pager, next, total"
      :page-size="10"
      :total="total"
      :current-page="queryinfo.page"
      @current-change="changepage"
    ></el-pagination>
    <el-dialog
      :title="editform.status == 0 ? $t('yh.shenhe') : $t('yh.xiangqing')"
      :visible="shenhevisible"
      :before-close="shenheclose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      custom-class="withdraw-dialog"
    >
      <div class="withdraw-info">
        <div class="header">
          <div class="withdraw-id">
            <span class="label">{{ $t('yh.txbh') }}:</span>
            <span class="value">{{ editform.id }}</span>
          </div>
          <div class="withdraw-status">
            <el-tag v-if="editform.status == 0" type="info">{{ $t('mmb.dsh') }}</el-tag>
            <el-tag v-else-if="editform.status == 1" type="success">{{ $t('tongguo') }}</el-tag>
            <el-tag v-else-if="editform.status == 2" type="danger">{{ $t('bohui') }}</el-tag>
          </div>
        </div>
        <el-divider content-position="left">{{ $t('yh.jbxx') }}</el-divider>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">{{ $t('yhm') }}:</span>
            <span class="value">{{ editform.username }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('yh.czsj') }}:</span>
            <span class="value">{{ dateFormat({ create_at: editform.create_at }) }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('yh.txfs') }}:</span>
            <span class="value">
              <el-tag v-if="editform.type == 0" type="primary" size="small">{{ $t('yh.yhk') }}</el-tag>
              <el-tag v-else-if="editform.type == 1" type="success" size="small">PayPay</el-tag>
            </span>
          </div>
        </div>
        <el-divider content-position="left">{{ $t('yh.txxx') }}</el-divider>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">{{ $t('yh.txsl') }}:</span>
            <span class="value highlight">{{ editform.money }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('yh.txsxf') }}:</span>
            <span class="value">{{ editform.withdraw_fee }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('yh.sjdz') }}:</span>
            <span class="value highlight">{{ editform.actual_amount }}</span>
          </div>
        </div>
        <template v-if="editform.type == 0">
          <el-divider content-position="left">{{ $t('yh.yhk') + $t('yh.txxx') }}</el-divider>
          <div class="info-grid">
            <div class="info-item">
              <span class="label">{{ $t('yh.yinhang') }}:</span>
              <span class="value" v-if="!isEditing">{{ editform.bank_name }}</span>
              <el-input v-else v-model="editform.bank_name" size="small" style="width: 200px"></el-input>
            </div>
            <div class="info-item">
              <span class="label">{{ $t('yh.zhihang') }}:</span>
              <span class="value" v-if="!isEditing">{{ editform.branch_name || '-' }}</span>
              <el-input v-else v-model="editform.branch_name" size="small" style="width: 200px"></el-input>
            </div>
            <div class="info-item">
              <span class="label">{{ $t('yh.zhanghu') }}:</span>
              <span class="value" v-if="!isEditing">{{ editform.account_name }}</span>
              <el-input v-else v-model="editform.account_name" size="small" style="width: 200px"></el-input>
            </div>
            <div class="info-item">
              <span class="label">{{ $t('yh.zhanghao') }}:</span>
              <span class="value" v-if="!isEditing">{{ editform.account_number }}</span>
              <el-input v-else v-model="editform.account_number" size="small" style="width: 200px"></el-input>
            </div>
            <div class="info-item">
              <span class="label">{{ $t('yh.zhanghuType') }}:</span>
              <span class="value" v-if="!isEditing">{{ editform.account_type || '-' }}</span>
              <el-input v-else v-model="editform.account_type" size="small" style="width: 200px"></el-input>
            </div>
          </div>
        </template>
        <template v-else-if="editform.type == 1">
          <el-divider content-position="left">PayPay {{ $t('yh.txxx') }}</el-divider>
          <div class="info-grid">
            <div class="info-item full-width">
              <span class="label">PayPay:</span>
              <span class="value" v-if="!isEditing">{{ editform.paypal_account }}</span>
              <el-input v-else v-model="editform.paypal_account" size="small" style="width: 300px"></el-input>
            </div>
          </div>
        </template>
        <el-divider content-position="left">{{ $t('beizhu') }}</el-divider>
        <el-form :model="editform" ref="editForm">
          <el-form-item>
            <el-input v-model="editform.remark" type="textarea" :rows="3" :placeholder="$t('qsr') + $t('beizhu')" :disabled="editform.status != 0 && !canUpdateRemark && !isEditing"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shenheclose">{{ $t('quxiao') }}</el-button>
        <template v-if="editform.status == 0">
          <el-button type="primary" @click="shenhesubmit(1)">{{ $t('tongguo') }}</el-button>
          <el-button type="danger" @click="shenhesubmit(2)">{{ $t('bohui') }}</el-button>
          <el-button type="warning" v-if="!isEditing" @click="startEditing">{{ $t('bianji') }}</el-button>
          <el-button type="success" v-if="isEditing" @click="saveEditing">{{ $t('save') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="updateRemark" v-if="canUpdateRemark && !isEditing">{{ $t('tijiao') }}</el-button>
          <el-button type="warning" v-if="!isEditing" @click="startEditing">{{ $t('bianji') }}</el-button>
          <el-button type="success" v-if="isEditing" @click="saveEditing">{{ $t('save') }}</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      queryinfo: {
        query: '',
        start: '',
        end: '',
        page: 1,
        status: 3,
        type: -1
      },
      infolist: [],
      total: 0,
      loading: true,
      editid: '',
      shenhevisible: false,
      editform: {
        remark: ''
      },
      canUpdateRemark: true,
      isEditing: false,
      originalFormData: null
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    async getlist() {
      this.loading = true
      try {
        const { data } = await this.$http.get('/admin/user/withdrawlog', {
          params: this.queryinfo
        })
        if (data && data.code === 200) {
          this.infolist = data.data.list.map(item => {
            return {
              ...item,
              status: isNaN(Number(item.status)) ? 0 : Number(item.status),
              type: isNaN(Number(item.type)) ? 0 : Number(item.type),
              money: isNaN(parseFloat(item.money)) ? '0.00' : parseFloat(item.money).toFixed(2),
              actual_amount: isNaN(parseFloat(item.actual_amount)) ? '0.00' : parseFloat(item.actual_amount).toFixed(2),
              withdraw_fee: isNaN(parseFloat(item.withdraw_fee)) ? '0.00' : parseFloat(item.withdraw_fee).toFixed(2)
            }
          })
          this.total = +data.data.count
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    changepage(val) {
      this.queryinfo.page = val
      this.getlist()
    },
    dateFormat(row) {
      const time = row.create_at || 0
      const dt = new Date(parseInt(time) * 1000)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')
      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    async shenhe(id) {
      this.shenhevisible = true
      this.editid = id
      this.isEditing = false
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255,255, 255, 0.7)',
        target: document.querySelector('.el-dialog__body')
      })
      try {
        const { data } = await this.$http.get('/admin/user/editwithdraw/id/' + id)
        if (data && data.code === 200) {
          this.editform = {
            ...data.data,
            status: isNaN(Number(data.data.status)) ? 0 : Number(data.data.status),
            type: isNaN(Number(data.data.type)) ? 0 : Number(data.data.type),
            money: isNaN(parseFloat(data.data.money)) ? '0.00' : parseFloat(data.data.money).toFixed(2),
            actual_amount: isNaN(parseFloat(data.data.actual_amount)) ? '0.00' : parseFloat(data.data.actual_amount).toFixed(2),
            withdraw_fee: isNaN(parseFloat(data.data.withdraw_fee)) ? '0.00' : parseFloat(data.data.withdraw_fee).toFixed(2),
            remark: data.data.remark || ''
          }
          this.originalFormData = JSON.parse(JSON.stringify(this.editform))
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        this.$message.error('请求失败')
      } finally {
        loading.close()
      }
    },
    async shenhesubmit(content) {
      try {
        const { data } = await this.$http.post('/admin/user/editwithdraw', {
          id: this.editid,
          action: 'sh',
          content: content,
          remark: this.editform.remark
        })
        if (data && data.code === 200) {
          this.getlist()
          this.$message.success(data.msg)
          this.shenheclose()
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        this.$message.error('操作失败')
      }
    },
    async updateRemark() {
      try {
        const { data } = await this.$http.post('/admin/user/editwithdraw', {
          id: this.editid,
          action: 'bz',
          content: this.editform.remark
        })
        if (data && data.code === 200) {
          this.getlist()
          this.$message.success(data.msg)
          this.shenheclose()
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        this.$message.error('备注更新失败')
      }
    },
    shenheclose() {
      this.shenhevisible = false
      this.editform = { remark: '' }
      this.isEditing = false
      this.originalFormData = null
    },
    getbystatus(command) {
      this.queryinfo.status = command
      this.getlist()
    },
    getbytype(command) {
      this.queryinfo.type = command
      this.getlist()
    },
    startEditing() {
      this.isEditing = true
      if (!this.originalFormData) {
        this.originalFormData = JSON.parse(JSON.stringify(this.editform))
      }
    },
    async saveEditing() {
      try {
        const submitData = {
          id: this.editid,
          action: 'update_info',
          type: this.editform.type
        }
        if (this.editform.type === 0) {
          submitData.bank_name = this.editform.bank_name
          submitData.branch_name = this.editform.branch_name
          submitData.account_name = this.editform.account_name
          submitData.account_number = this.editform.account_number
          submitData.account_type = this.editform.account_type
        } else if (this.editform.type === 1) {
          submitData.paypal_account = this.editform.paypal_account
        }
        const { data } = await this.$http.post('/admin/user/editwithdraw', submitData)
        if (data && data.code === 200) {
          this.$message.success('信息更新成功')
          this.getlist()
          this.isEditing = false
          this.originalFormData = JSON.parse(JSON.stringify(this.editform))
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        this.$message.error('信息更新失败')
      }
    },
    cancelEditing() {
      if (this.originalFormData) {
        this.editform = JSON.parse(JSON.stringify(this.originalFormData))
      }
      this.isEditing = false
    }
  }
}
</script>

<style lang="less" scoped>
.withdraw-dialog {
  .el-dialog__body {
    padding: 20px 30px;
  }
}
.withdraw-info {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EBEEF5;
    .withdraw-id {
      font-size: 16px;
      font-weight: bold;
      .value {
        margin-left: 5px;
        color: #606266;
      }
    }
  }
  .info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-bottom: 25px;
    .info-item {
      display: flex;
      align-items: center;
      &.full-width {
        grid-column: span 2;
      }
      .label {
        font-weight: bold;
        margin-right: 5px;
        color: #606266;
        min-width: 90px;
      }
      .value {
        color: #303133;
        &.highlight {
          color: #409EFF;
          font-weight: bold;
        }
      }
    }
  }
  .el-divider {
    margin: 20px 0;
    .el-divider__text {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
    }
  }
  .el-form {
    margin-top: 10px;
  }
}
.el-tag {
  display: inline-block;
  padding: 2px 6px;
  font-size: 12px;
}
</style>
